import BatteryModal from "components/StaticDashboard/UPS/UPSModal/UPSModal";
import ServerModal from "components/StaticDashboard/ServerModal/ServerModal";
import AirConditionerModal from "components/StaticDashboard/SRACModal/SRACModal";
import EquipmentMappingModal from "components/StaticDashboard/EquipmentMappingModal/EquipmentMappingModal";
import { useEffect, useState } from "react";
import { EquipmentProps } from "components/StaticDashboard/EquipmentMappingModal/EquipmentMappingModal";
import { getAllEquipments } from "api/equipments";
import Loader from "components/shared/Loader";
import { mapUnityEquipmentHash } from "api/tags";
import { singleChartData } from "components/StaticDashboard/UPS/Charts/config/LinesData";

type UnityEquipmentData = {
  Type: string | null;
  Hash: string | null;
};

type UnityEquipmentModalProps = {
  data: UnityEquipmentData;
  setData: React.Dispatch<React.SetStateAction<UnityEquipmentData>>;
  refreshUnityEquipmentsMeta: () => Promise<unknown>;
};

const UnityEquipmentModal: React.FC<UnityEquipmentModalProps> = ({ data, setData, refreshUnityEquipmentsMeta }) => {
  const [allEquipments, setAllEquipments] = useState<EquipmentProps[]>([]);
  const [mappedEquipment, setMappedEquipment] = useState<EquipmentProps | null>(null);
  const [mode, setMode] = useState<'modal' | 'mapping' | null>(null);
  const [equipmentMappingStatus, setEquipmentMappingStatus] = useState<'success' | 'fail' | null>(null);
  const [showModal, setShowModal] = useState(true);

  useEffect(() => {
    const fetchEquipments = async () => {
      const results = await getAllEquipments();
      if (results.status === 200) {
        setAllEquipments(results.data);
      }
    };
    fetchEquipments();
  }, [equipmentMappingStatus]);

  useEffect(() => {
    if (data.Type) {
      if (allEquipments.length > 0) {
        if (data.Hash) {
          const selectedEquipment = allEquipments.find((eq) => eq.unityHashId === data.Hash);
          console.log('mode', selectedEquipment);
          if (selectedEquipment) {
            setMode('modal');
            setMappedEquipment(selectedEquipment);
          } else {
            setMode('mapping');
          }
        }
      }
    }
  }, [allEquipments]);

  const mapEquipmentAction = async () => {
    const readyData = [{ id: mappedEquipment?.id, hashValue: data.Hash }];
    const response = await mapUnityEquipmentHash(readyData);
    if (response.status === 200 || response.status === 204) {
      setEquipmentMappingStatus('success');
      await refreshUnityEquipmentsMeta();
    } else {
      setEquipmentMappingStatus('fail');
    }
  };

  const onClose = () => {
    setMappedEquipment(null);
    setEquipmentMappingStatus(null);
    setMode(null);
    setShowModal(false);
    setData({ Type: null, Hash: null });
  };

  const onEdit = () => {
    setMode('mapping');
  };

  useEffect(() => {
    if (!showModal) {
      onClose();
    }
  }, [showModal]);

  return (
    <>
      {!mode &&
        <div className="h-screen w-screen bg-black/65 flex items-center justify-center fixed left-0 top-0 z-50"
          onClick={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
          onMouseUp={(e) => e.stopPropagation()}
          onMouseMove={(e) => e.stopPropagation()}
          onWheel={(e) => e.stopPropagation()}
          onContextMenu={(e) => e.preventDefault()}
        >
          <Loader />
        </div>
      }
      {
        mode === 'mapping' &&
        <EquipmentMappingModal onCancel={onClose} allEquipments={allEquipments} mappedEquipment={mappedEquipment} setMappedEquipment={setMappedEquipment} mapEquipmentAction={mapEquipmentAction} equipmentMappingStatus={equipmentMappingStatus} />
      }
      {mode === 'modal' &&
        <>
          {data.Type === 'Server' && <ServerModal title={mappedEquipment?.name} onClose={onClose} onEdit={onEdit} />}
          {data.Type === 'Battery' && <BatteryModal title={mappedEquipment?.name} chartData={singleChartData({ color: '#2DC75C' })} setShowModal={setShowModal} onEdit={onEdit} />}
          {data.Type === 'AirConditioner' && <AirConditionerModal onClose={onClose} onEdit={onEdit} />}
        </>
      }
    </>
  );
};

export default UnityEquipmentModal;